
import Vue from "vue";
import debounce from "lodash.debounce";
import { cloneDeep } from "@/helpers/object";

const defaultPagination = {
  page: 1,
  rowsPerPage: 10,
  descending: true,
};

export default Vue.extend({
  data() {
    return {
      search: null,
      // remove the 5 and "All" options
      rowsPerPageItems: [10, 25],
    };
  },
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: [Boolean, String],
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
    mustSort: {
      type: Boolean,
      default: true,
    },
    pagination: {
      type: Object,
    },
    disableInitialSort: {
      type: Boolean,
      default: false,
    },
    totalItems: {
      type: Number,
    },
    clientSideSearching: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.debounceOnPagination = debounce(this.onPagination, 500);
    this.debounceOnSearch = debounce(this.onSearch, 500);
  },
  computed: {
    localPagination() {
      return Object.assign({}, defaultPagination, this.$props.pagination || {});
    },
  },
  methods: {
    onPagination(value: any) {
      const payload = (this as any).enrichPagination(value);

      // This kinda hacky mess prevents duplicates from being called when
      // the table is first loaded, as there is an issue with the
      // component creating it's own object which triggers the method
      if (HasPaginationChanged(this.$props.pagination, value)) {
        return;
      }

      this.$emit("update:pagination", payload);
      this.$emit("pagination", payload);
    },
    onSearch(value: string) {
      const pagination = cloneDeep((this as any).localPagination);
      pagination.page = 1;

      const payload = (this as any).enrichPagination(pagination);

      this.$emit("update:pagination", payload);
      this.$emit("pagination", payload);
    },
    // Reshape vuetify pagination object into our own.
    enrichPagination(pagination: any) {
      return {
        ...pagination,
        search: (this as any).search,
        offset: pagination.page
          ? (Number(pagination.page) - 1) * pagination.rowsPerPage
          : undefined,
        sortDirection:
          typeof pagination.descending === "boolean"
            ? pagination.descending
              ? "descending"
              : "ascending"
            : undefined,
      };
    },
    mockFilter(val: any, search: string) {
      // dont filter anything
      return true;
    },
    mockSort(items: any[], search: string, filter: any) {
      // dont sort anything
      return items;
    },
  },
});

/**
 * Identifies if the datatable pagination object has changed.
 * Used to identify when the value has not changed, but the module just chose to
 * add extra data.
 */
function HasPaginationChanged(currentPagination: any, newPagination: any) {
  return (
    currentPagination &&
    currentPagination.descending === newPagination.descending &&
    currentPagination.offset === newPagination.offset &&
    currentPagination.page === newPagination.page &&
    currentPagination.rowsPerPage === newPagination.rowsPerPage &&
    currentPagination.sortBy === newPagination.sortBy &&
    currentPagination.sortDirection === newPagination.sortDirection
  );
}
